var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5965 4.75208C18.2858 4.29256 19.2171 4.47882 19.6766 5.16811L22 8.65314L24.3234 5.16811C24.7829 4.47882 25.7142 4.29256 26.4035 4.75208C27.0928 5.21161 27.279 6.14292 26.8195 6.83221L23.8028 11.3573L39.2313 34.5002H42C42.8284 34.5002 43.5 35.1717 43.5 36.0002C43.5 36.8286 42.8284 37.5002 42 37.5002H38.4518C38.4372 37.5004 38.4227 37.5004 38.4081 37.5002H28.4544C28.4381 37.5004 28.4218 37.5004 28.4056 37.5002H15.5944C15.5782 37.5004 15.5619 37.5004 15.5456 37.5002H5.59192C5.57735 37.5004 5.56277 37.5004 5.54818 37.5002H2C1.17157 37.5002 0.5 36.8286 0.5 36.0002C0.5 35.1717 1.17157 34.5002 2 34.5002H4.76865L20.1972 11.3573L17.1805 6.83221C16.721 6.14292 16.9072 5.21161 17.5965 4.75208ZM22 14.0615L8.3742 34.5002H14.741L22 22.9113L29.259 34.5002H35.6258L22 14.0615ZM25.719 34.5002L22 28.5627L18.281 34.5002H25.719Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTent);
export default __webpack_public_path__ + "static/media/tent.2259ad2114b73c1d8f70839faf5f07b6.svg";
export { ForwardRef as ReactComponent };